<template>
  <div class="brokerage_container">
    <div v-if="list.length > 0">
      <div>
        <div class="flex-row">
          <div class="keepWidth"></div>
          <div class="header">
            <div class="brokerage_price">
              <van-icon name="points"
                        class="pointsIcon" />
              <div class="totalPrice">{{ formatPrice(totalPrice) }}</div>
            </div>

            <div class="brokerage_title">当月税前工资</div>
            <span class="profitDesc"
                  @click="brokerageList">明细</span>
          </div>
          <div class="keepWidth"></div>
        </div>
      </div>

      <div class="dec">
        <p class="mounthTitle">日期</p>
        <p class="mounthTitle">税前工资</p>
      </div>
      <div class="main">
        <div class="list"
             id="list"
             v-for="(item, index) in list"
             :key="index">
          <div class="list_l">{{ item.month }}</div>
          <div>{{ formatPrice(item.percentage) }}</div>
        </div>
      </div>
      <div class="footerProfit">仅显示最近6个月的工资记录</div>
    </div>
    <div v-else
         class="index-empty">
      <div class="imageEmptySearch">
        <img src="../../../assets/images/search.png"
             alt />
      </div>
      你还没有工资记录哦...
    </div>
    <van-overlay :show="isLoading">
      <div class="wrapper">
        <loading v-if="isLoading == true"></loading>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Toast, Dialog, List, PullRefresh, NavBar, Icon, overlay } from "vant";
import loading from "../../components/loading/loading";
import { mapGetters, mapActions } from "vuex";
import service from "../../api/employeePage/index";
export default {
  name: "qecode",
  data () {
    return {
      totalPrice: 0,
      isLoading: true, //loading状态
      list: [],
      orderPrice: 50,
      firstLoading: true
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
    [overlay.name]: overlay,
    loading,
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted () {
    // console.log(this.list[0].percentage,69)
    this.init();
  },
  methods: {
    formatPrice (price) {
      return price.toFixed(2);
      // if (price >= 1) {
      //   return price.toFixed(2);
      // } else {
      //   return price;
      // }
    },
    init () {
      // this.totalPrice = this.$route.query.price;
      this.firstLoading = true;
      service
        .percentageList()
        .then((response) => {
          console.log(response, 80);
          setTimeout(() => {
            this.isLoading = false;
          }, 600);
          if (response.statusCode == 200) {
            response.data.map((i) => {
              if (i.isCurrent) {
                this.totalPrice = i.percentage;
              }
            });
            this.list = response.data;
            this.firstLoading = true;
          } else {
            this.firstLoading = false;
            Toast(response.errors);
          }
        })
        .catch((error) => {
          this.firstLoading = false;
          // Toast(error);
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });
    },
    onClickLeft () {
      this.$router.go(-1);
    },
    brokerageList () {
      // Toast('功能暂未开发，敬请期待')
      this.$router.push("brokerageList");
    }
  }
};
</script>
<style lang="less" scoped>
// @deep: ~">>>";
.brokerage_container {
  height: 100vh;
  .pointsIcon {
    margin-top: 1vw;
    margin-right: 3px;
    font-size: 12px;
  }
  .mounthTitle {
    margin: 7px 0;
  }
  .flex-row {
    background-image: url(../../../assets/images/profitBgr.png);
    background-repeat: no-repeat;
    background-size: 100vw 84px;
  }
  .footerProfit {
    color: #b8b8b8;
    font-size: 3.2vw;
    width: 100%;
    text-align: center;
    margin-top: 9.06vw;
  }
  .dec {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 17px;
    font-size: 13px;
    background: #f8f8f8;
    border-top: 1px solid #f8f8f8;
    color: #464646;
    margin-top: 3.2vw;
  }
  .flex {
    display: flex;
    align-items: center;
  }
  .brokerage_price {
    display: flex;
    font-size: 15px;
    justify-content: center;
    align-items: center;
    height: 50px;
    // height: 55px;
  }
}
.header {
  background: RGBA(255, 255, 255, 0.85);
  text-align: center;
  color: #000;
  flex: 1;
  height: 114px;
  // height: 108px;
  margin: 26px auto 0;
  box-shadow: 0px 6px 17px 0px rgba(236, 12, 35, 0.08);
  border-radius: 10px;
  padding-top: 1vw;

  .brokerage_title {
    height: 34px;
    line-height: 11vw;
    // height: 40px;
    // line-height: 13vw;
    color: #8d8d8d;
  }
  .profitDesc {
    color: #e8414e;
    font-size: 12px;
  }
  .totalPrice {
    font-size: 21px;
  }
}
.main {
  margin: 1vw 0;
  background: #fff;
  padding: 0 0.8vw;
}
.list {
  display: flex;
  padding: 1vw 2vw 1vw 0;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgba(230, 230, 230, 1);
  margin: 0 4vw;
  .shop {
    color: #b3b3b3;
    font-size: 12px;
  }
  .list_l {
    height: 40px;
    line-height: 40px;
  }
}
</style>